<template>
  <div>
    <v-row>
      <v-col cols="12">
        <TipoCalculo v-model="model" @changeTipoCalculo="changeTipoCalculo"/>
      </v-col>
      <v-col cols="12">
        <input-select v-if="!model.Codigo && !model.GarantiaSimulacao" label="Tipo de Operação" v-model="model.TipoOperacaoCred"
          @change="changeOperacao" :options="operacao" required />
        <input-text v-else label="Tipo de Operação" :value="model.TipoOperacaoNome" readonly disabled />
      </v-col>
        <v-col cols="12">
          <input-select v-if="!model.Codigo && !model.GarantiaSimulacao" label="Produto" v-model="model.TipoContratoSigla" @change="changeProduto"
            :options="produtos" return-object required/>
          <input-text v-else label="Produto" :value="model.TipoContratoDescricao" readonly disabled required/>
        </v-col>
        <v-col cols="12" class="py-0" v-if="!model.HasGarantia && model.TipoOperacaoCred !== 2 && model.TipoContratoSigla">
          <v-alert type="error" text>
            Não existe garantia cadastrada para esse produto
          </v-alert>
        </v-col>
    </v-row>
    <v-row v-if="enabledAmortizacao">
      <v-col cols="12">
        <input-select label="Tipo Imóvel" v-model="model.TipoImovel" :options="tiposImovel" return-object required @change="model.IsentarIOF = false" :disabled="!!model.Codigo"/>
      </v-col>
      <v-col cols="12" class="pt-0 mt-0" v-if="model.TipoImovel === 'Residencial' && isPF">
        <v-checkbox v-model="model.IsentarIOF" label="Isentar IOF" class="pt-0 mt-0" :disabled="!!model.Codigo"/>
      </v-col>
      <v-col cols="12">
        <input-select label="Divisão de Négocio" v-model="model.DivisaoNegocio" :options="['Desenvolvimento Urbano', 'Incorporação Vertical']" return-object
          required :disabled="!!model.Codigo" @change="changeDivisaoNegocio"/>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-label>Amortização</v-label>
        <input-radiogroup name="Amortização" row v-model="model.ModeloCalculo" required :disabled="!!model.Codigo">
          <v-radio v-for="modelo in modelos" :key="modelo.value" :label="modelo.label" :value="modelo.value"/>
        </input-radiogroup>
      </v-col>
    </v-row>
    <v-row>
        <v-col cols="6">
          <input-select label="Tipo de Assinatura" :options="assinaturas" v-model="model.TipoCCB" required>
          </input-select>
        </v-col>
      <v-col cols="12" class="pt-0">
        <v-label>Modalidade</v-label>
        <input-radiogroup name="Indexador" row v-model="model.TipoIndexador" @change="changeIndexador" required>
          <v-radio label="Pré-Fixado" :value="1" />
          <v-radio label="Pós-Fixado" :value="2" />
        </input-radiogroup>
      </v-col>
      <v-col cols="6">
        <input-select label="Indexador Pós Fixado" v-model="model.TipoIndiceFinan"
          :options="indexadores" :disabled="model.TipoIndexador !== 2"
          :required="model.TipoIndexador === 2" />
      </v-col>
      <v-col cols="6">
        <input-number label="Percentual Indexador" v-model="model.PercIndiceFinan"
          format="percent" :disabled="model.TipoIndexador !== 2"
          :required="model.TipoIndexador === 2" />
      </v-col>
      <v-col cols="6">
        <input-number v-if="this.model.TipoContratoSigla === 'FI'" label="Taxa de Juros a.a." v-model="model.PercJurosAnual" precision="5" max="999.99999"
          format="percent" required />
        <input-number v-else label="Taxa de Juros a.m." v-model="model.PercJurosMensal" precision="5" max="999.99999"
          format="percent" required />
      </v-col>
    </v-row>

    <PropostaEditDesembolso ref="desembolso" :value="model" @response="responseDesembolso"></PropostaEditDesembolso>
  </div>
</template>

<script>
export default {
  components: {
    PropostaEditDesembolso: () => import('./PropostaEditDesembolso.vue')
  },
  props: {
    value: null,
    isNotaComercial: { type: Boolean, default: false },
    isPF: null
  },
  data () {
    return {
    }
  },
  computed: {
    modelos () {
      return this.$param.ModeloCalculoProduto[this.model.TipoContratoSigla]
    },
    tiposImovel () {
      return ['Residencial', 'Comercial']
    },
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    produtos () {
      const lista = this.$api.Estruturadas.GetProdutos(
        this.model.Cliente.DocumentoFederal,
        this.model.TipoOperacaoCred,
        this.$param.EST_PRODUTOS
      )
      return lista
    },
    assinaturas () {
      if (this.isNotaComercial) return this.$api.Estruturadas.TipoAssinatura.filter(tipo => tipo.value === 'D')
      const lista = this.$api.Estruturadas.GetProdutos(
        this.model.Cliente.DocumentoFederal,
        this.model.TipoOperacaoCred,
        this.$param.EST_PRODUTOS,
        this.model.TipoContratoSigla,
      )
      return lista
    },
    operacao () {
      const tipoOperacao = this.$api.Estruturadas.GetTipoOperacaoByTipoPessoa(
        this.model.Cliente.DocumentoFederal,
        this.$param.EST_PRODUTOS
      );
      return tipoOperacao;
    },
    tipoPessoaString () {
      const th = this
      var tipoPessoa = th.$api.UI.Format.SomenteNumeros(th.model.Cliente.DocumentoFederal).length === 11 ? 'PF' : 'PJ'
      return tipoPessoa
    },
    enabledAmortizacao () {
      const th = this
      const pf = th.$api.UI.Format.SomenteNumeros(th.model.DocumentoFederal).length === 11
      const index = th.$param.ProdutosSAC.findIndex(produto => (
        produto.PF === pf || produto.PJ === !pf) &&
        produto.TipoOperacao === th.model.TipoOperacaoCred &&
        produto.TipoContrato === th.model.TipoContratoSigla &&
        produto.TipoCalculo === th.model.TipoCalculoFluxo
      )
      return index >= 0
    },
    indexadores () {
      const itens = this.$param.Indexadores[this.model.TipoContratoSigla]
      if (itens) {
        return itens
      } else {
        return this.$param.Indexadores.TODOS
      }
    }
  },
  methods: {
    changeDivisaoNegocio (value) {
      const th = this
      if (value === 'Desenvolvimento Urbano') {
        th.$set(th.model, 'TipoCampoSeguroDFI', null)
        th.$set(th.model, 'VlrSeguroMensal2', null)
        th.$set(th.model, 'PercSeguroMensal2', null)
      }
    },
    load () {
      this.$refs.desembolso.load()
      this.$set(this.model, 'HasGarantia', true)
    },
    changeOperacao (value) {
      this.load()
      this.$set(this.model, 'TipoOperacaoNome', null);
      if (value) { this.$set(this.model, 'TipoOperacaoNome', this.$api.Estruturadas.TipoOperacaoCred.find(p => p.value === value).text); }
      this.$set(this.model, 'TipoIndiceFinan', null);
      this.$set(this.model, 'QtdeParcelasSolicitado', null);
      this.$set(this.model, 'Produto', null);
      this.$set(this.model, 'ModeloCalculo', null);
      this.$set(this.model, 'TipoIndexador', null);
      this.$set(this.model, 'PercIndiceFinan', null);
      this.$set(this.model, 'OutrosServicos', false);
      this.$set(this.model, 'VlrSolicitado', null);
      this.$set(this.model, 'VlrProdutoBem', null)
      this.$set(this.model, 'VlrTAC', null);
      this.$set(this.model, 'VlrSeguro', null)
      this.$set(this.model, 'VlrAvaliacao', null)
      this.$set(this.model, 'VlrVistoria', null)
      this.$set(this.model, 'TipoContratoSigla', null);
      this.$set(this.model, 'TipoCCB', null);
      this.$set(this.model, 'PercJurosMensal', null);
      if (this.produtos?.length === 0) {
        this.$api.UI.Mensagem('Alerta', 'N�o existe Produto definido para este tipo de Pessoa/Opera��o')
      }
      this.clearAmortizacao()
    },
    changeProduto (item) {
      const th = this
      th.load()
      th.$set(th.model, 'TipoContrato', null)
      if (item && item.value) {
        th.$set(th.model, 'TipoContratoSigla', item.value)
        th.$set(th.model, 'TipoContratoTela', item.value)
        th.$set(th.model, 'TipoContratoDescricao', item.value + ' - ' + item.text)
      }
      th.getGarantias()
      th.clearAmortizacao()
      if (item && item.value === 'FI') {
        th.$set(th.model, 'ModeloCalculo', th.$param.TipoAmortizacaoPadrao)
      }
    },
    getGarantias () {
      const param = this.$api.Estruturadas.garantiaBySigla(this)
      if (this.model.TipoOperacaoCred !== 2 && param) {
        if (param.garantias) {
          this.$set(this.model, 'HasGarantia', true)
        } else {
          this.$set(this.model, 'HasGarantia', false)
        }
      }
    },
    submit () {
      const th = this
      const produtosFiltrados = th.$param.EST_PRODUTOS.filter(el => el.TipoOperacao === th.model.TipoOperacaoCred && el.TipoPessoa === th.tipoPessoaString).reduce(l => l).Produtos
      if (produtosFiltrados.length > 0) {
        th.$set(th.model, 'CodigoVersaoCCB', produtosFiltrados.find(el => el.Sigla === th.model.TipoContratoSigla)[th.model.TipoCCB])
        th.$refs.desembolso.submit()
      } else {
        th.$api.UI.ShowError('Não foi possível encontrar o Código do Tipo de Operação Parâmetrizado')
      }
    },
    responseDesembolso (response) {
      const th = this
      th.model.Promotor = {}
      if (response.TipoDesembolso === th.$api.Enums.TipoDesembolso.Outros) {
        th.model.Promotor = response.Promotor
      }
      th.$set(th.model, 'TipoDesembolso', response.TipoDesembolso)
      th.$set(th.model, 'ContaPagamento', response.ContaPagamento)
      th.$set(th.model, 'Identificador', response.Identificador)

      if (th.model.Codigo) {
        th.$api.Estruturadas.SaveProposta(th, function (response) {
          th.$emit('nextStep')
        })
      } else { th.$emit('nextStep') }
    },
    changeIndexador () {
      const th = this;
      if (th.model.TipoIndexador === 1) {
        th.$set(th.model, 'TipoIndiceFinan', '')
        th.$set(th.model, 'PercIndiceFinan', '')
      }
    },
    changeTipoCalculo () {
      const th = this
      th.clearAmortizacao()
    },
    clearAmortizacao () {
      const th = this
      if (th.model.TipoContratoSigla === 'FI') {
        th.$set(th.model, 'ModeloCalculo', th.$param.TipoAmortizacaoPadrao)
      } else {
        th.$set(th.model, 'ModeloCalculo', th.$aux.ModeloCalculoEnum.Price)
      }
      th.$set(th.model, 'TipoImovel', null);
      th.$set(th.model, 'DivisaoNegocio', null);
      th.$set(th.model, 'IsentarIOF', null);
    }
  }
}
</script>
